module.exports = __webpack_public_path__ + "static/img/cover.c8c9256.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/cover.png
// module id = Tk/h
// module chunks = 1